import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiX } from 'react-icons/fi';
import { TOEFL_SETTINGS_PATH } from './Activation.jsx';
import { fetchToeflBootcamp } from './api.js';
import {
  dismissToeflProposal,
  isToeflProposalDismissed,
  resolveToeflProposal,
} from './toeflOffer.js';
import './ToeflNextStepCard.css';

const COPY = {
  journey_complete: {
    title: 'Your IELTS journey is complete — consider TOEFL',
    body: 'At this level the 2026 TOEFL iBT is often shorter and more practical than another IELTS cycle. Nothing starts automatically — you choose in Settings.',
    compact: 'The 2026 TOEFL iBT is often faster at this level. You activate it only in Settings.',
  },
  reached_c1: {
    title: 'You’re at C1 — TOEFL can be the shorter next step',
    body: 'Once your tests reach C1, many schools accept TOEFL and the 2026 iBT is usually quicker to sit. You activate it only in Settings — nothing starts automatically.',
    compact: 'At C1, TOEFL is often the shorter next exam. You activate it only in Settings.',
  },
};

export default function ToeflNextStepCard({
  journey,
  progress,
  currentLevel,
  bandScore,
  bootcamp: bootcampProp,
  compact = false,
}) {
  const navigate = useNavigate();
  const [bootcamp, setBootcamp] = useState(
    bootcampProp && bootcampProp.status ? bootcampProp : null
  );
  const [ready, setReady] = useState(Boolean(bootcampProp && bootcampProp.status));
  const [dismissed, setDismissed] = useState(() => isToeflProposalDismissed());

  useEffect(() => {
    if (bootcampProp && bootcampProp.status) {
      setBootcamp(bootcampProp);
      setReady(true);
      return undefined;
    }

    let cancelled = false;
    fetchToeflBootcamp()
      .then((state) => {
        if (!cancelled) {
          setBootcamp(state);
          setReady(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setBootcamp(null);
          setReady(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [bootcampProp]);

  const proposal = resolveToeflProposal({
    journey,
    progress,
    currentLevel,
    bandScore,
    bootcamp,
    dismissed,
  });

  if (!ready || !proposal.show) return null;

  const copy = COPY[proposal.reason] || COPY.reached_c1;

  return (
    <section
      className={`toefl-next-step-card${compact ? ' toefl-next-step-card--compact' : ''}`}
    >
      <button
        type="button"
        className="toefl-next-step-card__dismiss"
        aria-label="Dismiss TOEFL suggestion"
        onClick={(event) => {
          event.stopPropagation();
          dismissToeflProposal();
          setDismissed(true);
        }}
      >
        <FiX />
      </button>
      <h3>{copy.title}</h3>
      <p>{compact ? copy.compact : copy.body}</p>
      <button
        type="button"
        className="toefl-next-step-card__cta"
        onClick={(event) => {
          event.stopPropagation();
          navigate(TOEFL_SETTINGS_PATH);
        }}
      >
        Open TOEFL in Settings
      </button>
    </section>
  );
}
